import React, {ReactElement, SVGProps} from 'react';
import cn from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';

// Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.
interface MegaphoneIconProps extends SVGProps<SVGSVGElement> {
  tooltip?: ReactElement | string;
}

export const MegaphoneIcon: React.FC<MegaphoneIconProps> = props => {
  return (
    <Tooltip title={props.tooltip ?? ''}>
      <svg
        {...props}
        className={cn(props.className, 'icon megaphone')}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 576 512">
        <path d="M576 64V448C576 465.7 561.7 480 544 480C526.3 480 512 465.7 512 448V64C512 46.33 526.3 32 544 32C561.7 32 576 46.33 576 64zM63.96 190.3L480 64V448L348.9 408.2C338.2 449.5 300.7 480 256 480C202.1 480 160 437 160 384C160 372.1 161.9 362.3 165.3 352.5L63.96 321.7C63.07 338.6 49.1 352 32 352C14.33 352 0 337.7 0 320V192C0 174.3 14.33 160 32 160C49.1 160 63.07 173.4 63.96 190.3V190.3zM302.9 394.2L211.3 366.4C209.2 371.9 208 377.8 208 384C208 410.5 229.5 432 256 432C278.1 432 298.2 415.8 302.9 394.2V394.2z" />
      </svg>
    </Tooltip>
  );
};
